<div class="min-h-dvh flex items-center justify-center bg-background-light px-6">
  <div class="max-w-md w-full text-center bg-white rounded-xl shadow-card-elevated p-8">
    <a href="/" class="inline-block mb-6">
      <img ngSrc="assets/images/logo_transparent_rectangle.png" alt="corpers.ng logo" class="w-28 mx-auto" width="410" height="65" priority>
    </a>

    <ng-container *ngIf="status === 'form'">
      <h2 class="text-2xl font-bold text-primary mb-2">Forgot your password?</h2>
      <p class="text-text-secondary mb-6">Enter your email and we'll send you a link to reset it.</p>

      <form class="grid gap-2 text-left">
        <mat-form-field class="full-width" appearance="fill">
          <mat-label>Email</mat-label>
          <input matInput type="email" autocomplete="email" [formControl]="email" placeholder="" />
          <mat-error *ngIf="email.hasError('email') && !email.hasError('required')">
            Please enter a valid email address
          </mat-error>
          <mat-error *ngIf="email.hasError('required')">
            Email is <strong>required</strong>
          </mat-error>
        </mat-form-field>

        <app-progress-button type="submit" class="mt-4" (click)="submit()"
          buttonText="Send reset link" [loading]="isSubmitting"
          [disabled]="email.invalid || isSubmitting"></app-progress-button>
      </form>
    </ng-container>

    <ng-container *ngIf="status === 'sent'">
      <mat-icon class="!text-5xl !w-auto !h-auto text-primary">mark_email_read</mat-icon>
      <h2 class="text-2xl font-bold text-primary mt-4 mb-2">Check your inbox</h2>
      <p class="text-text-secondary mb-6">If an account exists for that email, we've sent a link to reset your password.</p>
    </ng-container>

    <div class="text-center mt-6">
      <a routerLink="/login" class="underline text-primary hover:text-primary-dark transition-colors">Back to login</a>
    </div>
  </div>
</div>
